import {Helmet} from 'react-helmet-async';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ModifierTable from './ModifierTable';
import ModifierWizard from './ModifierWizard';
import './ModifierTool.css';

const {FiArrowLeft,FiBookOpen}=FiIcons;

function ModifierTool() {
  return (
    <>
      <Helmet>
        <title>CPT &amp; HCPCS Modifier Lookup Tool | Medical Coding Class</title>
        <meta
          name="description"
          content="Quick lookup tool for CPT and HCPCS Level II modifiers with clinical coding examples and use cases."
        />
      </Helmet>
      <main className="modifier-page">
        <section className="modifier-hero">
          <div className="container">
            <button
              style={{marginTop: '0px'}}
              className="back-link"
              onClick={()=> window.history.back()}
            >
              <SafeIcon icon={FiArrowLeft} /> Back to Study Tools
            </button>
            <span style={{marginLeft: '10px'}} className="eyebrow">
              CPT and HCPCS exam preparation
            </span>
            <h1>Modifier Selector Tool</h1>
            <p>
              Two-character modifiers clarify procedural circumstances without
              changing the core definition of the service.
            </p>
          </div>
        </section>
        <section className="modifier-section">
          <div className="container">
            <div className="modifier-intro">
              <SafeIcon icon={FiBookOpen} />
              <p>
                Use the wizard as a study aid, then verify the current CPT,
                HCPCS, payer, and documentation requirements before assigning a
                modifier.
              </p>
            </div>
            <ModifierWizard />
            <ModifierTable />
            <p className="modifier-disclaimer">
              Educational tool only. Modifier selection depends on complete
              clinical documentation, code-specific guidance, payer policy, and
              applicable edits.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}

export default ModifierTool;